import React from 'react';
import TypeOfDetections from './TypeOfDetections';

const View = ({ data }) => {
    return (
        <div>
        <TypeOfDetections data={data}/>
        </div>
    );
}

export default View;
